// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@conklin/App/Components/Notify";
import { changeCustomerSelectCustomerContainerStyles } from "@conklin/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionHidden = {
    css: css`
        display: none;
    `,
};

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionVisible = {
    css: css`
        font-size: 12px;
        margin-top: 20px;
    `,
};

changeCustomerSelectCustomerContainerStyles.container = {
    gap: 20,
    css: css`
        &&&& {
            max-width: 450px;
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.billToSelectorGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        align-items: stretch;
        border-top: 1px solid ${color("common.border")};
        padding-top: 20px;
        margin-top: 4px;
    `,
};

changeCustomerSelectCustomerContainerStyles.billingAddressTitle = {
    weight: 700,
    css: css`
        margin-bottom: 8px;
    `,
};

changeCustomerSelectCustomerContainerStyles.billingAddressPlaceholder = {
    italic: true,
    color: "text.disabled",
};

changeCustomerSelectCustomerContainerStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        border-top: 1px solid ${color("common.border")};
        padding-top: 20px;
        ${xScreen("lte", "xs")} {
            flex-direction: column-reverse;
            row-gap: 20px;
            button {
                width: 100%;
                margin: 0;
            }
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionVisible = {
    ...mergeWithCss(getNotifyStyle("info"), {
        css: css`
            margin-top: 20px;
            margin-bottom: 0;
        `,
    }),
};

changeCustomerSelectCustomerContainerStyles.requiredSelectionModal = {
    modal: {
        sizeVariant: "small",
    },
    messageText: {
        css: css`
            display: block;
            margin-bottom: 8px;
        `,
    },
};
